import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import Tooltip from '@atlaskit/tooltip';
import { messages } from '@databases/intl/messages';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

interface ClosePanelButtonProps {
  onClose: () => void;
  tooltipMessage?: string;
}

const ClosePanelButton: FunctionComponent<ClosePanelButtonProps> = ({
  onClose,
  tooltipMessage,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      content={
        tooltipMessage
          ? tooltipMessage
          : formatMessage(messages['generic-panel.close-button'])
      }
    >
      {(tooltipProps) => (
        <IconButton
          {...tooltipProps}
          appearance="subtle"
          icon={CrossIcon}
          label={formatMessage(messages['generic-panel.close-button'])}
          onClick={onClose}
          testId="close-panel-button"
        />
      )}
    </Tooltip>
  );
};

export default ClosePanelButton;
